var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-sent-harassment.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6f6045f8!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-sent-harassment.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageSentHarassment.vue
// module id = 1325
// module chunks = 1